/**
 * Log data constants for the Feed
 */
export const ORIGIN_KEY = 'Origin';
export const FEED_CONTENT_ID_KEY = 'FeedContentId';

export const FEED_ORIGIN = 'Feed';
export const EXPLORE_ORIGIN = 'Explore';
export const HOME_ORIGIN = 'Home';
export const USER_TIMELINE_ORIGIN = 'UserTimeline';
export const TEAM_PROFILE_ORIGIN = 'TeamProfile';
export const FEATURED_ATHLETES_ORIGIN = 'FeaturedAthletes';
export const MINI_PROFILE_ORIGIN = 'MiniProfile';

const WHO_REACTED_BASE = 'WhoReacted';
export const WHO_REACTED_FEED_ORIGIN = WHO_REACTED_BASE + FEED_ORIGIN;
export const WHO_REACTED_USER_TIMELINE_ORIGIN = WHO_REACTED_BASE + USER_TIMELINE_ORIGIN;
export const WHO_REACTED_TEAM_PROFILE_ORIGIN = WHO_REACTED_BASE + TEAM_PROFILE_ORIGIN;

const TAG_BASE = 'Tag';
export const TAG_FEED_ORIGIN = TAG_BASE + FEED_ORIGIN;
export const TAG_USER_TIMELINE_ORIGIN = TAG_BASE + USER_TIMELINE_ORIGIN;
export const TAG_TEAM_PROFILE_ORIGIN = TAG_BASE + TEAM_PROFILE_ORIGIN;

export const CARD_TAG_MODAL = 'CardTagModal';
